<template>
    <div v-if="isFaqTreeExist && !isParamsHasPreset || isMeyaOpened" class="header__nav-buttons">
        <button
            class="header__button"
            :disabled="!isBackAvailable"
            @click="goBack"
        >
            <span class="header__icon header__icon_type_arrow-back" />
        </button>
        <button
            class="header__button"
            :disabled="!isForwardAvailable"
            @click="goForward"
        >
            <span class="header__icon header__icon_type_arrow-forward" />
        </button>
        <button
            class="header__button"
            :disabled="!isHomeAvailable"
            @click="goHome"
        >
            <span class="header__icon header__icon_type_home" />
        </button>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'TheHeaderNavigation',
    data: () => ({
        isForwardAvailable: false,
    }),
    computed: {
        ...mapState({
            isFaqTreeExist: state => state.FAQ.isFaqTreeExist,
            feedBackQuestionList: state => state.feedback.feedbackQuestionList,
            previousPage: state => state.routing.referer,
            queryParams: state => state.queryParams
        }),
        ...mapGetters({
            rootTreeItemPath: 'FAQ/getRootTreeItemPath',
        }),
        isParamsHasPreset() {
            return 'preset' in this.queryParams;
        },
        isNotRootFaqCategory() {
            return this.rootTreeItemPath !== this.$route.fullPath;
        },
        isEnableOnlyFallbackPage() {
            return !this.isFaqTreeExist && !this.feedBackQuestionList.length;
        },
        isBackAvailable() {
            return this.isNotRootFaqCategory && !this.isEnableOnlyFallbackPage && this.previousPage !== '/';
        },
        isHomeAvailable() {
            return this.isFaqTreeExist && this.isNotRootFaqCategory && !this.isEnableOnlyFallbackPage || this.isMeyaOpened;
        },
        isMeyaOpened() {
            return this.$route.meta.headerTitle === 'chat'
        },
    },
    watch: {
        '$route.path'() {
            this.updateForwardAvailability();
        },
    },
    methods: {
        updateForwardAvailability() {
            this.isForwardAvailable = !!this.$router.options.history.state.forward;
        },
        goBack() {
            this.$router.go(-1)
        },
        goForward() {
            this.$router.go(+1)
        },
        goHome() {
            this.$router.push('/')
        }
    }
}
</script>
